import React, { createContext, FC, memo, useState } from 'react';

import { useSafeContext } from 'hooks/useSafeContext/useSafeContext';
import { ModalType } from 'components/PageLayout/Modals/types';

export type ModalState = {
  modalType?: ModalType;
  setModalType: (modalType?: ModalType) => void
};

const ModalContext = createContext<ModalState | undefined>(undefined);
// eslint-disable-next-line
ModalContext.displayName = 'Modals';

export const ModalProvider: FC = memo(function ModalProvider({ children }) {
  const [modalType, setModalType] = useState<ModalType>();

  const values = {
    modalType,
    setModalType,
  };

  return (
    <ModalContext.Provider value={values}>
      {children}
    </ModalContext.Provider>
  );
});

export function useModals() {
  return useSafeContext(useModals, ModalContext);
}
